import { render, staticRenderFns } from "./expiring-soon.vue?vue&type=template&id=3e713974&scoped=true&"
import script from "./expiring-soon.vue?vue&type=script&lang=js&"
export * from "./expiring-soon.vue?vue&type=script&lang=js&"
import style0 from "./expiring-soon.vue?vue&type=style&index=0&id=3e713974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e713974",
  null
  
)

export default component.exports